import { Component, Input } from '@angular/core';
import { UigTermsConditionsDialogComponent } from '../uig-terms-conditions-dialog/uig-terms-conditions-dialog.component';
import {LaunchDialogService} from "@spartacus/storefront";
import {take} from "rxjs/operators";
import {Observable} from "rxjs";

@Component({
    selector: 'app-uig-terms-conditions-note',
    templateUrl: './uig-terms-conditions-note.component.html',
    styleUrls: ['./uig-terms-conditions-note.component.scss'],
    standalone: false
})
export class UigTermsConditionsNoteComponent {
  @Input() hideButtons:boolean =false;
  

  private dialog: Observable<any>;
  constructor(private launchDialogService: LaunchDialogService) {}

  openTermsAndConditions() {
    const openTermsAndConditionsData = {
      redirectToLogin: false,
      hideButtons: this.hideButtons
    };
    this.dialog = this.launchDialogService.openDialog('TERMS_CONDITIONS', undefined, undefined, openTermsAndConditionsData);
    this.dialog?.pipe(take(1)).subscribe();
  }
}
